import React from 'react';
import { CinematicExperience } from '../components/experience/CinematicExperience';
import SEOHead from '../components/SEOHead';

// Home is now the cinematic scroll-driven landing page.
// All other pages (Solutions, Portfolio, Blog, etc.) remain unchanged.
export const Home = () => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'RADIUS CONSULTING',
    url: 'https://radiusconsulting.co.za',
    description:
      'Strategy-led, design-driven, outcome-focused. Marketing, brand, and go-to-market consultancy for ambitious businesses.',
  };
  return (
    <>
      <SEOHead
        title="RADIUS CONSULTING — Strategy-Led. Design-Driven. Outcome Focused."
        description="Connecting the dots that matter. Growth tools and strategy for ambitious businesses."
        keywords="brand strategy, marketing, AI, go-to-market, retail experience, South Africa"
        schema={schema}
      />
      <CinematicExperience />
    </>
  );
};

export default Home;
